import { useState, useEffect, useContext } from "react";
import axios from "axios";
import React from "react";
import MyContext from "../../../MyContext";
const POSPayment = ({
  cart,
  totalPrice,
  reciptDetails,
  setTenderedAmount,
  tenderedAmount,
  placeOrderApi,
  userID,
  setScreen,
  orderType,
  selectedDiscount,
  setSelectedDiscount,
  orderId,
  setShowUPIModal,
  gstClaim,
  sgst,
  cgst,
  paymentMethods,
  selectedPaymentMethods,
  setSelectedPaymentMethods,
  dueAmount,
  paidAmount,
  orderStatus,
  setRemarks,
  remarks,
  placeOrderLoader,
  setOtherPaymentMethodModal,
  otherPaymentMethodModal,
  setAssignToPackkyModal,
  assignToPackkyModal,
  setDeliveryChargesDeductedFrom,
  deliveryChargesDeductedFrom,
  setDeliveryPartner,
  deliveryPartner,
  apiLoader


}) => {
  const [change, setChange] = useState(0);
  const { baseUrl } = useContext(MyContext);
  const { config } = useContext(MyContext);
  const [showDiscountModal, setShowDiscountModal] = useState(false);
  const [selectedPaymentMethodForRemarks, setSelectedPaymentMethodForRemarks] = useState(false);
  const [discountList, setDiscountList] = useState([]);
  const [newDiscount, setNewDiscount] = useState({});
  const [appliedDiscount, setAppliedDiscount] = useState(null);
  const [deliveryCharges, setDeliveryCharges] = useState(reciptDetails.deliveryCharges || 0);
  const keypadFull = [
    [1, 7, 8, 9],
    [2, 4, 5, 6],
    [5, 1, 2, 3],
    [10, 0, "00", "."],
    [20, 50, 100, "Clear"],
  ];

  useEffect(() => {
    const tender = parseFloat(tenderedAmount || "0");
    const changeDue = tender - totalPrice;
    setChange(changeDue > 0 ? changeDue : 0);
  }, [tenderedAmount, totalPrice]);

  const getDiscountApi = async () => {
    const payload = {
      userid: userID,
      amount: totalPrice,
      orderType: orderId,
    };

    try {
      const { data } = await axios.post(
        `${baseUrl}/api/Order/v1.0/getPosDiscountList`,
        payload,
        config
      );

      if (data.responseCode === "00") {
        setDiscountList(data.response);
      } else {
        // alert("Error: " + data.responseMessage);
      }
    } catch (error) {
      // alert("Failed to fetch discounts");
      console.error("API error:", error);
    }
  };
  const applyDiscountApi = async () => {
    const payload = {
      orderId: orderId,
      discountId: newDiscount.id,
    };

    try {
      const { data } = await axios.post(
        `${baseUrl}/api/Order/v1.0/selectDiscountPosOrder`,
        payload,
        config
      );

      if (data.responseCode === "00") {
        setSelectedDiscount(newDiscount.discountAmount);
        setAppliedDiscount(newDiscount);
        setShowDiscountModal(false);
      } else {
        // alert("Error: " + data.responseMessage);
      }
    } catch (error) {
      // alert("Failed to fetch discounts");
      console.error("API error:", error);
    }
  };
  const removeDiscountApi = async () => {
    const payload = {
      orderId: orderId,
      discountId: newDiscount.id,
    };

    try {
      const { data } = await axios.post(
        `${baseUrl}/api/Order/v1.0/removeDiscountPosOrder`,
        payload,
        config
      );

      if (data.responseCode === "00") {
        setSelectedDiscount(0.00);
        setNewDiscount({});
        setAppliedDiscount(null);
        setShowDiscountModal(false);
      } else {
        // alert("Error: " + data.responseMessage);
      }
    } catch (error) {
      // alert("Failed to fetch discounts");
      console.error("API error:", error);
    }
  };
  useEffect(() => {
    getDiscountApi();
  }, []);
  const handleKeyClick = (value) => {
    if (value === "Clear") {
      setTenderedAmount("");
    } else {
      setTenderedAmount((prev) => prev + value.toString());
    }
  };


  const discountedPrice = totalPrice - selectedDiscount;
  // const gstAmount = gstClaim === "Y" ? discountedPrice * 0.05 : 0;
  // Parse cgst and sgst as numbers
  const cgstRate = parseFloat(cgst) || 0;
  const sgstRate = parseFloat(sgst) || 0;
  const totalGstRate = gstClaim === "Y" ? cgstRate + sgstRate : 0;

  // Calculate GST amount
  const gstAmount = (discountedPrice * totalGstRate) / 100;
  const totalWithGST = discountedPrice + gstAmount;

  const handleExact = () => setTenderedAmount(Number(totalWithGST.toFixed(2)));
  const handleRound = () => setTenderedAmount(Math.ceil(totalWithGST));

  const handlePaymentMethodSelect = (method) => {
    setSelectedPaymentMethodForRemarks(method);
    // setOtherPaymentMethodModal(false);
  };

  // When user confirms OK after typing remarks
  const handleConfirmRemarks = () => {
    placeOrderApi(userID, cart, selectedPaymentMethodForRemarks, remarks);
    setSelectedPaymentMethodForRemarks(null);
    setOtherPaymentMethodModal(false);
    setRemarks("");
  };

  // Cancel action
  const handleCancelRemarks = () => {
    setSelectedPaymentMethodForRemarks(false);
    setRemarks("");
  };
  const PrintSeriveApiCall = async (UserId, OrderID) => {
    // setLoading(true);
    try {
      const requestBody = {
        userid: UserId,
        orderId: OrderID
      };
      const response = await axios.post(
        `${baseUrl}/api/Order/v1.0/processPrint`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {

      }
    } catch {
    } finally {
      // setLoading(false);
    }
  };

  const [showChargeOptions, setShowChargeOptions] = useState(false);
  const [tempDeliveryCharge, setTempDeliveryCharge] = useState(
    Number(reciptDetails.deliveryCharges) || 0
  );
  const chargeOptions = [0, 20, 25, 50, 100];

  const packkyBaseAmount = Number(totalPrice) - Number(selectedDiscount);

  const packkyGstAmount =
    gstClaim === "Y"
      ? (packkyBaseAmount * ((parseFloat(cgst) || 0) + (parseFloat(sgst) || 0))) / 100
      : 0;

  const packkyFinalTotal = packkyBaseAmount + packkyGstAmount + Number(tempDeliveryCharge || 0);
  useEffect(() => {
    if (assignToPackkyModal) {
      setTempDeliveryCharge(Number(deliveryCharges) || Number(reciptDetails.deliveryCharges) || 0);
      setShowChargeOptions(false);
    }
  }, [assignToPackkyModal, deliveryCharges, reciptDetails.deliveryCharges]);
  return (
    <>
      {/* {JSON.stringify(keypad)} */}
      <div className="col-5 p-0 m-0">
        <div className="d-flex flex-column h-100">
          {/* Header */}
          <div>
            <h4
              className="text-center py-2 text-dark bg-light"
              style={{ borderBottom: "1px solid #111" }}
            >
              Order Summary
            </h4>
          </div>

          {/* Scrollable Cart Content */}
          <div
            className="flex-grow-1 overflow-auto p-2"
            style={{
              maxHeight: "calc(100vh - 440px)", // Adjust to fit total height minus header + totals + footer
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            {cart.length > 0 ? (
              <table className="table-bordered border-dark align-middle m-0 w-100">
                <thead className="border-dark">
                  <tr>
                    <th className="text-center p-2 bg-light">Unit</th>
                    <th className="text-center p-2 bg-light">Item</th>
                    <th className="text-center p-2 bg-light">Unit Price</th>
                    <th className="text-center p-2 bg-light">Total Price</th>
                  </tr>
                </thead>
                <tbody>
                  {cart.map((item, index) => (
                    <tr key={index} style={{ borderBottom: "1px solid #000" }}>
                      <td className="text-center p-2 fw-bold">
                        {item.quantity}
                      </td>
                      <td className="text-center p-2 fw-bold">
                        {item.item_name}
                      </td>
                      <td className="text-center p-2 fw-bold">
                        ₹ {item.prices[0].price}
                      </td>
                      <td className="text-center p-2 fw-bold">
                        ₹ {(item.prices[0].price * item.quantity).toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="text-center py-4 text-muted">Cart is empty</div>
            )}
          </div>

          {/* Totals Section - Fixed at bottom of summary panel */}
          <div
            className="border-top px-3 bg-white"
            style={{
              height: "210px", // Increased height to accommodate extra tax rows
              flexShrink: 0,
            }}
          >
            <h5 className="d-flex justify-content-between py-1 pt-3">
              <span>Subtotal</span>
              <span>₹ {totalPrice}</span>
            </h5>

            <h5 className="d-flex justify-content-between py-1">

              <span>Discount</span>
              <span>- ₹ {selectedDiscount}</span>
            </h5>


            {(parseFloat(cgst) > 0 || parseFloat(sgst) > 0) && gstClaim === "Y" && (
              <>
                {/* Tax Breakdown (with percentage) */}
                <h5 className="d-flex justify-content-between py-1">
                  <span>CGST ({parseFloat(cgst).toFixed(1)}%)</span>
                  <span>
                    ₹ {(((totalPrice - selectedDiscount) * parseFloat(cgst)) / 100).toFixed(2)}
                  </span>
                </h5>
                <h5 className="d-flex justify-content-between py-1">
                  <span>SGST ({parseFloat(sgst).toFixed(1)}%)</span>
                  <span>
                    ₹ {(((totalPrice - selectedDiscount) * parseFloat(sgst)) / 100).toFixed(2)}
                  </span>
                </h5>
              </>
            )}

            {(parseFloat(cgst) > 0 || parseFloat(sgst) > 0) && gstClaim !== "Y" && (
              <>
                {/* Tax Breakdown (without percentage) */}
                <h5 className="d-flex justify-content-between py-1">
                  <span>CGST ({parseFloat(cgst).toFixed(1)}%)</span>
                  <span>
                    ₹ {(((totalPrice - selectedDiscount) * parseFloat(cgst)) / 100).toFixed(2)}
                  </span>
                </h5>
                <h5 className="d-flex justify-content-between py-1">
                  <span>SGST ({parseFloat(cgst).toFixed(1)}%)</span>
                  <span>
                    ₹ {(((totalPrice - selectedDiscount) * parseFloat(sgst)) / 100).toFixed(2)}
                  </span>
                </h5>
              </>
            )}


            <hr className="my-2 border-dark" />

            <h4 className="d-flex justify-content-between fw-bold py-1">
              <span>Total</span>
              <span>
                ₹{" "}
                {(
                  (totalPrice - selectedDiscount) *
                  (1 + ((gstClaim === "Y" ? (parseFloat(cgst) + parseFloat(sgst)) : 0) / 100))
                ).toFixed(2)}
              </span>
            </h4>
            {orderStatus === "partially_paid" &&
              <>
                <h4 className="d-flex justify-content-between  py-1">
                  <span>Paid Amount</span>
                  <span>
                    ₹{" "}
                    {Number(paidAmount).toFixed(2)}
                  </span>
                </h4>
                <h4 className="d-flex justify-content-between  py-1">
                  <span>Due Amount</span>
                  <span>
                    ₹{" "}
                    {Number(dueAmount).toFixed(2)}
                  </span>
                </h4>
              </>
            }
          </div>
        </div>
      </div>
      <div className="col-5 p-2 m-0 border-start border-dark">
        <div>
          <div className="row col-12 m-0 p-0 d-flex justify-content-center ">
            <div className="bg-white  p-4 mx-3 mb-4 border">
              {/* Due */}
              <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-3">
                <div className="d-flex align-items-center gap-2">
                  <i className="bi bi-exclamation-circle text-warning"></i>
                  <h5 className="m-0">Due Amount</h5>
                </div>
                {orderStatus === "partially_paid" ?
                  <>
                    <h4 className="m-0 fw-bold text-dark fs-3 me-2">
                      ₹{" "} {Number(dueAmount).toFixed(2)}
                    </h4>
                  </> :
                  <h4 className="m-0 fw-bold text-dark fs-3 me-2">
                    ₹{" "}
                    {(
                      (totalPrice - selectedDiscount) *
                      (1 + (gstClaim === "Y" ? ((parseFloat(cgst) || 0) + (parseFloat(sgst) || 0)) / 100 : 0))
                    ).toFixed(2)}
                  </h4>}
              </div>







              {/* Tendered */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center gap-2">
                  <i className="bi bi-cash-coin text-dark"></i>
                  <h5 className="m-0">Tendered Amount : </h5>
                </div>
                <input
                  type="text"
                  inputMode="decimal"
                  min="0"
                  step="0.01"
                  className="form-control form-control-lg text-end fw-bold text-dark p-2 fs-3"
                  style={{
                    maxWidth: "380px",
                    border: "2px solid #000",
                    borderRadius: "0.5rem",
                  }}
                  value={tenderedAmount}
                  onChange={(e) =>
                    setTenderedAmount(parseFloat(e.target.value) || 0)
                  }
                  placeholder="₹ 0.00"
                />
              </div>


            </div>
            {keypadFull.map((item) => (
              <div
                className="row col-12 m-0 p-0 d-flex justify-content-between"
              // style={{width:"530px"}}
              >
                {item.map((element) => (
                  <div className="col-3  ">
                    <button
                      type="button"
                      onClick={() => handleKeyClick(element)}
                      style={{ height: "80px", width: "100%" }}
                      className="scale-button shadow border border-secondary m-2 cursor-pointer rounded  bg-light  d-flex justify-content-center align-items-center fs-5 fw-bold"
                    >
                      {element}
                    </button>
                  </div>
                ))}
              </div>
            ))}
            <div className="col-6">
              <button
                type="button"
                disabled={orderStatus === "partially_paid"}
                style={{ height: "80px", width: "100%" }}
                onClick={handleExact}
                className="scale-button shadow border border-secondary m-2 cursor-pointer rounded  bg-light  d-flex justify-content-center align-items-center fs-5 fw-bold"
              >
                EXACT
              </button>
            </div>
            {/* Round Button Here */}
            {/* <div className="col-6">
              <button
              disabled={orderStatus==="partially_paid"}
                type="button"
                onClick={handleRound}
                style={{ height: "80px", width: "100%" }}
                className="scale-button shadow border border-secondary m-2 cursor-pointer rounded  bg-light  d-flex justify-content-center align-items-center fs-5 fw-bold"
              >
                ROUND
              </button>
            </div> */}

            <div className="col-6">
              <button
                disabled={orderStatus === "partially_paid"}
                onClick={() => setShowDiscountModal(true)}
                style={{ height: "80px", width: "100%" }}
                className="scale-button shadow border border-secondary m-2 cursor-pointer rounded  bg-light  d-flex justify-content-center align-items-center fs-5 fw-bold"
              >
                DISCOUNT
              </button>
            </div>
            {/* <div className="col-6">
          <POSPrint cart={cart} reciptDetails={reciptDetails}/>
            </div>  */}
            <div className="col-6"></div>
          </div>
        </div>
        <div></div>
      </div>
      <div className="col-2 p-2 m-0 border-start border-dark">
        <div className="p-2">
          <button
            onClick={() => { PrintSeriveApiCall(userID, orderId); placeOrderApi(userID, cart, "cash"); }}
            // disabled={tenderedAmount < (Number(totalPrice)-Number(selectedDiscount))}
            disabled={tenderedAmount < 1 || apiLoader}

            style={{ height: "120px", width: "100%" }}
            className="scale-button shadow border border-secondary m-2 cursor-pointer rounded  bg-gray  d-flex justify-content-center align-items-center fs-5 fw-bold"
          >
            CASH
          </button>
        </div>
        <div className="p-2">
          <button
            // disabled
            onClick={() => setShowUPIModal(true)}
            style={{ height: "120px", width: "100%" }}
            className="scale-button shadow border border-secondary m-2 cursor-pointer rounded  bg-gray  d-flex justify-content-center align-items-center fs-5 fw-bold"
          >
            UPI
          </button>
        </div>

        <div className="p-2">
          <button
            disabled={apiLoader}
            onClick={() => { setOtherPaymentMethodModal(true) }}
            style={{ height: "120px", width: "100%" }}
            className="scale-button shadow border border-secondary m-2 cursor-pointer rounded  bg-gray  d-flex justify-content-center align-items-center fs-5 fw-bold"
          >
            OTHER
          </button>
        </div>
        {orderType === "homedelivery" &&
          <div className="p-2">
            <button
              disabled={apiLoader}
              onClick={() => { setAssignToPackkyModal(true); setDeliveryPartner("packky") }}
              style={{ height: "120px", width: "100%" }}
              className="scale-button shadow border border-secondary m-2 cursor-pointer rounded  bg-gray  d-flex justify-content-center align-items-center fs-5 fw-bold"
            >
              ASSIGN TO PACKKY
            </button>
          </div>
        }






        <div className="p-2">
          <button
            onClick={() => setScreen("Catalog")}
            style={{ height: "120px", width: "100%" }}
            className="scale-button shadow border border-secondary m-2 cursor-pointer rounded  bg-gray  d-flex justify-content-center align-items-center fs-5 fw-bold"
          >
            BACK
          </button>
        </div>
        <div className="p-2">
          <button
            onClick={() => setScreen("OrderType")}
            style={{ height: "120px", width: "100%" }}
            className="scale-button shadow border border-secondary m-2 cursor-pointer rounded  bg-gray  d-flex justify-content-center align-items-center fs-5 fw-bold"
          >
            CANCEL
          </button>
        </div>
      </div>
      {showDiscountModal && (
        <div
          className="position-fixed top-50 start-50 translate-middle bg-white text-center p-5 rounded-4 shadow"
          style={{ width: "1000px", zIndex: 1050 }}
        >
          <div className="row col-12 m-0 p-0">
            {/* Discount List Section */}
            <div className="col-8 p-4 bg-white rounded text-start">
              <h1 className="mb-4 text-center">Available Discounts</h1>
              {discountList.length > 0 ? (
                discountList.map((item) => (
                  <div
                    key={item.id}
                    className={`position-relative mb-4 p-4 border shadow rounded cursor-pointer ${item.id === newDiscount?.id ? "bg-green-order text-white" : "bg-light"
                      }`}
                    onClick={() => {
                      setNewDiscount(item);
                    }}
                  >
                    {/* Badge for applied discount */}
                    {item.id === appliedDiscount?.id && (
                      <span
                        className="position-absolute top-0 end-0 bg-success text-white px-2 py-1 rounded-start"
                        style={{ fontSize: "0.8rem" }}
                      >
                        APPLIED
                      </span>
                    )}
                    <p className="mb-1 fs-3">
                      Discount: <strong>{Number(item.discount).toFixed(2)}%</strong>
                    </p>
                    <p className="mb-0 fs-3">
                      Discount Amount: <strong>₹ {item.discountAmount}</strong>
                    </p>
                  </div>
                ))
              ) : (
                <p>No discounts available.</p>
              )}
            </div>

            {/* Button Section */}
            <div
              style={{ borderLeft: "3px dashed #000" }}
              className="col-4 p-2 d-flex flex-column justify-content-center align-items-center"
            >
              <button
                disabled={!newDiscount?.id || newDiscount?.id === appliedDiscount?.id}
                onClick={() => applyDiscountApi()}
                style={{ height: "120px", width: "250px" }}
                className="scale-button shadow border border-secondary m-2 rounded bg-gray d-flex justify-content-center align-items-center fs-4 fw-bold"
              >
                APPLY
              </button>

              <button
                disabled={!newDiscount?.id || newDiscount?.id !== appliedDiscount?.id}
                onClick={() => removeDiscountApi()}
                style={{ height: "120px", width: "250px" }}
                className="scale-button shadow border border-secondary m-2 rounded bg-gray d-flex justify-content-center align-items-center fs-4 fw-bold"
              >
                REMOVE
              </button>

              <button
                onClick={() => setShowDiscountModal(false)}
                style={{ height: "120px", width: "250px" }}
                className="scale-button shadow border border-secondary m-2 rounded bg-gray d-flex justify-content-center align-items-center fs-4 fw-bold"
              >
                CANCEL
              </button>
            </div>
          </div>
        </div>
      )}


      {otherPaymentMethodModal && (
        <div
          className="position-fixed top-50 start-50 translate-middle bg-white text-center p-5 rounded-4 shadow"
          style={{ width: "1000px", zIndex: 1050 }}
        >
          <div className="row col-12 m-0 p-0">
            {/* Left Side: Payment Method List */}
            <div className="col-8 p-4 bg-white rounded text-start">
              <h1 className="mb-4 text-center">Select Payment Method</h1>
              {paymentMethods.length > 0 ? (
                paymentMethods.map((item) => (
                  <div
                    key={item.id}
                    className={`mb-4 p-4 border shadow rounded cursor-pointer ${selectedPaymentMethodForRemarks === item.method
                      ? "bg-green-order text-white "
                      : ""
                      }`}
                    onClick={() => handlePaymentMethodSelect(item.method)}
                  >
                    <p className="mb-0 fs-3">
                      <strong>{item.method}</strong>
                    </p>
                  </div>
                ))
              ) : (
                <p>No payment method available.</p>
              )}
            </div>

            {/* Right Side: Remarks + OKAY + CLOSE */}
            <div
              style={{ borderLeft: "3px dashed #000" }}
              className="col-4 p-4 d-flex flex-column justify-content-center align-items-center"
            >
              {/* Reference Input */}
              <div className="w-100 mb-4 text-start">
                <label className="form-label fs-5 fw-bold mb-2">Reference Number</label>

                {selectedPaymentMethodForRemarks ? (
                  <input
                    type="text"
                    className="form-control fs-4 px-4 py-3 rounded-3 shadow-sm border border-dark"
                    placeholder="Enter reference no. (e.g. UPI TXN12345, ₹100 advance)"
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    autoFocus
                    style={{
                      backgroundColor: "#fff",
                      height: "60px",
                    }}
                  />
                ) : (
                  <input
                    type="text"
                    className="form-control fs-4 px-4 py-3 rounded-3 shadow-sm border border-dark"
                    placeholder="Select a payment method first"
                    disabled
                    style={{
                      backgroundColor: "#f0f0f0",
                      height: "60px",
                    }}
                  />
                )}
              </div>

              {/* OKAY Button */}
              <button
                onClick={() => {
                  placeOrderApi(userID, cart, selectedPaymentMethodForRemarks, remarks.trim());
                  setSelectedPaymentMethodForRemarks(null);
                  setRemarks("");
                }}
                disabled={
                  !selectedPaymentMethodForRemarks || remarks.trim().length < 3
                }
                style={{ height: "100px", width: "250px" }}
                className=" scale-button shadow border border-secondary mb-4 rounded-3 bg-light d-flex justify-content-center align-items-center fs-4 fw-bold"
              >
                {!placeOrderLoader ? "OKAY" : "Placing..."}
              </button>

              {/* CLOSE Button */}
              <button
                onClick={() => {
                  setOtherPaymentMethodModal(false);
                  setRemarks("");
                  setSelectedPaymentMethodForRemarks(null);
                }}
                style={{ height: "100px", width: "250px" }}
                className="scale-button shadow border border-secondary rounded-3 bg-light d-flex justify-content-center align-items-center fs-4 fw-bold"
              >
                CLOSE
              </button>
            </div>

          </div>
        </div>
      )}


      {assignToPackkyModal && (
        <div
          className="position-fixed top-50 start-50 translate-middle bg-white text-center p-5 rounded-4 shadow"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", width: "1000px", zIndex: 1050 }}
        >
          <div className="row col-12 m-0 p-0">
            {/* Left Side */}
            <div className="col-8 p-2 bg-white rounded text-start">
              <h1 className="mb-4 text-center">Assign To Packky</h1>

              <div className="d-flex flex-column h-100">
                <div
                  className="border-top px-3 bg-white"
                  style={{ minHeight: "260px", flexShrink: 0 }}
                >
                  <h5 className="d-flex justify-content-between py-1 pt-3">
                    <span>Subtotal</span>
                    <span>₹ {Number(totalPrice).toFixed(2)}</span>
                  </h5>

                  <h5 className="d-flex justify-content-between py-1">
                    <span>Discount</span>
                    <span>- ₹ {Number(selectedDiscount).toFixed(2)}</span>
                  </h5>

                  {(parseFloat(cgst) > 0 || parseFloat(sgst) > 0) && (
                    <>
                      <h5 className="d-flex justify-content-between py-1">
                        <span>CGST ({parseFloat(cgst).toFixed(1)}%)</span>
                        <span>
                          ₹{" "}
                          {(
                            ((Number(totalPrice) - Number(selectedDiscount)) * parseFloat(cgst || 0)) /
                            100
                          ).toFixed(2)}
                        </span>
                      </h5>

                      <h5 className="d-flex justify-content-between py-1">
                        <span>SGST ({parseFloat(sgst).toFixed(1)}%)</span>
                        <span>
                          ₹{" "}
                          {(
                            ((Number(totalPrice) - Number(selectedDiscount)) * parseFloat(sgst || 0)) /
                            100
                          ).toFixed(2)}
                        </span>
                      </h5>
                    </>
                  )}

                  {/* Show delivery charges under SGST */}
                  <h5 className="d-flex justify-content-between py-1">
                    <span>Delivery Charges</span>
                    <span>₹ {Number(tempDeliveryCharge || 0).toFixed(2)}</span>
                  </h5>

                  <hr className="my-2 border-dark" />

                  <h4 className="d-flex justify-content-between fw-bold py-1">
                    <span>Total</span>
                    <span>₹ {packkyFinalTotal.toFixed(2)}</span>
                  </h4>

                  {orderStatus === "partially_paid" && (
                    <>
                      <h4 className="d-flex justify-content-between py-1">
                        <span>Paid Amount</span>
                        <span>₹ {Number(paidAmount).toFixed(2)}</span>
                      </h4>
                      <h4 className="d-flex justify-content-between py-1">
                        <span>Due Amount</span>
                        <span>₹ {Number(dueAmount).toFixed(2)}</span>
                      </h4>
                    </>
                  )}

                  <div className="mt-3 p-2 border rounded bg-light">
                    <h6 className="fw-bold text-muted mb-0">
                      {Number(tempDeliveryCharge) > 0 ? (
                        <span>
                          Note: Delivery charges are collected from the{" "}
                          <span className="text-danger">customer</span>.
                        </span>
                      ) : (
                        <span>
                          Note: Delivery charges are covered by the{" "}
                          <span className="text-danger">restaurant</span>.
                        </span>
                      )}
                    </h6>
                  </div>
                  {/* Charge Selector Footer */}
                  {showChargeOptions && (
                    <div className="mt-3 p-2 border rounded bg-white shadow-sm">
                      <h6 className="fw-bold mb-2 text-center">Select Delivery Charges</h6>

                      <div className="d-flex justify-content-center flex-wrap gap-2">
                        {chargeOptions.map((charge) => {
                          const isActive = Number(tempDeliveryCharge) === Number(charge);

                          return (
                            <button
                              key={charge}
                              type="button"
                              onClick={() => setTempDeliveryCharge(charge)}
                              className={`btn fw-bold ${isActive ? "btn-success" : "btn-outline-secondary"
                                }`}
                              style={{
                                minWidth: "90px",
                                fontSize: "1rem",
                              }}
                            >
                              ₹ {charge}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Right Side */}
            <div
              style={{ borderLeft: "3px dashed #000" }}
              className="col-4 p-4 d-flex flex-column justify-content-center align-items-center"
            >
              <button
                onClick={() => {
                  setDeliveryCharges(Number(tempDeliveryCharge) || 0);
                  setDeliveryChargesDeductedFrom(
                    Number(tempDeliveryCharge) > 0 ? "restaurant":"customer" 
                  );
                  setAssignToPackkyModal(false);
                }}
                style={{ height: "100px", width: "250px" }}
                className="scale-button shadow border border-secondary mb-4 rounded-3 bg-light d-flex justify-content-center align-items-center fs-4 fw-bold"
              >
                OKAY
              </button>

              <button
                onClick={() => setShowChargeOptions((prev) => !prev)}
                style={{ height: "100px", width: "250px" }}
                className="scale-button shadow border border-secondary mb-3 rounded-3 bg-light d-flex justify-content-center align-items-center fs-4 fw-bold text-success"
              >
                ADD CHARGES
              </button>



              <button
                onClick={() => {
                  setTempDeliveryCharge(Number(deliveryCharges) || 0);
                  setShowChargeOptions(false);
                  setAssignToPackkyModal(false);
                }}
                style={{ height: "100px", width: "250px" }}
                className="scale-button shadow border border-secondary rounded-3 bg-light d-flex justify-content-center align-items-center fs-4 fw-bold"
              >
                CLOSE
              </button>
            </div>
          </div>
        </div>
      )}






    </>
  );
};

export default POSPayment;
